import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { BRAND, SEGMENTS, WHATSAPP_URL } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-noise text-white mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link to="/" aria-label="Ir para a página inicial da Wellpec">
            <img
              src="/images/brand/wellpec-logo-footer.png"
              alt="Wellpec — Sua energia. Nossa especialidade."
              className="block h-auto w-[270px] sm:w-[320px] lg:w-[360px] max-w-full"
              loading="lazy"
            />
          </Link>
          <p className="mt-6 text-sm text-white/70 leading-relaxed max-w-xs">
            Fornecimento especializado de materiais consumíveis e spare parts
            para operações industriais críticas.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.22em] text-bronze font-semibold">
            Navegação
          </div>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li><Link to="/" className="hover:text-bronze-soft">Início</Link></li>
            <li><Link to="/sobre" className="hover:text-bronze-soft">Sobre</Link></li>
            <li><Link to="/produtos" className="hover:text-bronze-soft">Produtos</Link></li>
            <li><Link to="/clientes" className="hover:text-bronze-soft">Clientes</Link></li>
            <li><Link to="/codigo-de-etica" className="hover:text-bronze-soft">Código de Ética</Link></li>
            <li><Link to="/contato" className="hover:text-bronze-soft">Contato</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.22em] text-bronze font-semibold">
            Segmentos
          </div>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            {SEGMENTS.map((segment) => (
              <li key={segment.title}>{segment.title}</li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-bronze font-semibold">
            Contato
          </div>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2">
              <Mail className="h-4 w-4 mt-0.5 text-bronze" />
              <a
                href={`mailto:${BRAND.email}`}
                data-testid="footer-email"
                className="hover:text-bronze-soft break-all"
              >
                {BRAND.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Phone className="h-4 w-4 mt-0.5 text-bronze" />
              <a
                href={WHATSAPP_URL()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="hover:text-bronze-soft"
              >
                {BRAND.whatsappDisplay} · WhatsApp
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 mt-0.5 text-bronze" />
              <span>{BRAND.address}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <span>© {new Date().getFullYear()} {BRAND.name}. Todos os direitos reservados.</span>
          <span>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-bronze-soft">
              Acesso interno
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
